 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accessDenied":"accessDenied","dashboard":"dashboard","empresas-editar~pedidos-detail":"empresas-editar~pedidos-detail","empresas-editar":"empresas-editar","pagamentos-detail~pedidos-detail":"pagamentos-detail~pedidos-detail","pedidos-detail":"pedidos-detail","empresas-list":"empresas-list","forgot-password":"forgot-password","funcionalidades-list":"funcionalidades-list","funcionalidades-novo":"funcionalidades-novo","login":"login","notFound":"notFound","npm.xlsx":"npm.xlsx","npm.jspdf":"npm.jspdf","pagamentos-list":"pagamentos-list","pedidos-list":"pedidos-list","pagamentos-detail":"pagamentos-detail","perfis-list":"perfis-list","perfis-novo":"perfis-novo","profile":"profile","reset-password":"reset-password","tipo-pedido-list":"tipo-pedido-list","tipo-pedido-novo":"tipo-pedido-novo","usuarios-list":"usuarios-list","usuarios-novo":"usuarios-novo","npm.canvg":"npm.canvg","npm.performance-now":"npm.performance-now","npm.dompurify":"npm.dompurify","npm.html2canvas":"npm.html2canvas"}[chunkId]||chunkId) + "." + {"accessDenied":"23beac96","dashboard":"d56d1019","empresas-editar~pedidos-detail":"f5b09b4a","empresas-editar":"46d05b67","pagamentos-detail~pedidos-detail":"5b4baa10","pedidos-detail":"df16d7a6","empresas-list":"c587ac3f","forgot-password":"a725872d","funcionalidades-list":"cf96c661","funcionalidades-novo":"c1b11c6c","login":"c9d7ec54","notFound":"b849e0c9","npm.xlsx":"cfa5e002","npm.jspdf":"fb968a3e","pagamentos-list":"97c08ff3","pedidos-list":"603389de","pagamentos-detail":"3bae9073","perfis-list":"20729a70","perfis-novo":"160a1854","profile":"2d08a2f2","reset-password":"f7ef9726","tipo-pedido-list":"1e3d1a5b","tipo-pedido-novo":"5affd40a","usuarios-list":"6fceaed1","usuarios-novo":"52e67cb8","npm.canvg":"e1c2e08e","npm.performance-now":"cc375167","chunk-565a9da1":"1986850f","npm.dompurify":"9f51c06b","npm.html2canvas":"152617a0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accessDenied":1,"dashboard":1,"pedidos-detail":1,"forgot-password":1,"login":1,"notFound":1,"perfis-novo":1,"reset-password":1,"tipo-pedido-novo":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accessDenied":"accessDenied","dashboard":"dashboard","empresas-editar~pedidos-detail":"empresas-editar~pedidos-detail","empresas-editar":"empresas-editar","pagamentos-detail~pedidos-detail":"pagamentos-detail~pedidos-detail","pedidos-detail":"pedidos-detail","empresas-list":"empresas-list","forgot-password":"forgot-password","funcionalidades-list":"funcionalidades-list","funcionalidades-novo":"funcionalidades-novo","login":"login","notFound":"notFound","npm.xlsx":"npm.xlsx","npm.jspdf":"npm.jspdf","pagamentos-list":"pagamentos-list","pedidos-list":"pedidos-list","pagamentos-detail":"pagamentos-detail","perfis-list":"perfis-list","perfis-novo":"perfis-novo","profile":"profile","reset-password":"reset-password","tipo-pedido-list":"tipo-pedido-list","tipo-pedido-novo":"tipo-pedido-novo","usuarios-list":"usuarios-list","usuarios-novo":"usuarios-novo","npm.canvg":"npm.canvg","npm.performance-now":"npm.performance-now","npm.dompurify":"npm.dompurify","npm.html2canvas":"npm.html2canvas"}[chunkId]||chunkId) + "." + {"accessDenied":"431b388d","dashboard":"ecbcdd13","empresas-editar~pedidos-detail":"31d6cfe0","empresas-editar":"31d6cfe0","pagamentos-detail~pedidos-detail":"31d6cfe0","pedidos-detail":"d6bab712","empresas-list":"31d6cfe0","forgot-password":"164f8976","funcionalidades-list":"31d6cfe0","funcionalidades-novo":"31d6cfe0","login":"548b5506","notFound":"6e9f5125","npm.xlsx":"31d6cfe0","npm.jspdf":"31d6cfe0","pagamentos-list":"31d6cfe0","pedidos-list":"31d6cfe0","pagamentos-detail":"31d6cfe0","perfis-list":"31d6cfe0","perfis-novo":"c875a12d","profile":"31d6cfe0","reset-password":"c8e833c4","tipo-pedido-list":"31d6cfe0","tipo-pedido-novo":"b0e9d0a3","usuarios-list":"31d6cfe0","usuarios-novo":"31d6cfe0","npm.canvg":"31d6cfe0","npm.performance-now":"31d6cfe0","chunk-565a9da1":"31d6cfe0","npm.dompurify":"31d6cfe0","npm.html2canvas":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
